@let obs =
  {
    bannerSearch: bannerSearch$ | async,
    isDesktop: isDesktop$ | async,
  };

<div
  class="banner-search"
  (click)="onClickBanner(obs.bannerSearch)"
  [sdInViewport]="0.5"
  [intersectedOnce]="true"
  (intersected)="onBannerIntersect(obs.bannerSearch)"
>
  @let link = obs.bannerSearch?.link;

  @if (link) {
    <sd-generic-link [url]="link">
      @if (obs.bannerSearch?.url) {
        <img [ngSrc]="obs.bannerSearch?.url" fill priority />
      }
    </sd-generic-link>
  } @else {
    @let url = obs.bannerSearch?.url;

    @if (url) {
      <img [ngSrc]="url" fill priority />
    }
  }
  <div class="banner-search__input-wrapper" [sdOutsideViewport] (isOutside)="updateVisibility($event)">
    <sd-searchbox-container data-testid="banner-search">
      @if (obs.isDesktop) {
        <a
          [routerLink]="['/catalog']"
          class="link-black link-hover-orange link-hover-underlined banner-search__catalog-link"
        >
          <sd-icon class="icon-size-m color-black" type="menu"></sd-icon>
        </a>
      }
    </sd-searchbox-container>
  </div>
</div>
